module.exports = __webpack_public_path__ + "img/tpc-18.93b80619.webp";